export enum PhoneTypes {
  Fijo = 'FIJO',
  Celular = 'CELULAR',
}
export interface PhoneType {
  label: PhoneTypes;
  value: PhoneTypes;
}
